export default "__VITE_ASSET__fe069560__"